import React, { PropsWithChildren } from 'react';
import { Text } from '@clariness/clarikit-react';

export const AccountPageLayoutParagraph = ({
  children,
}: PropsWithChildren<unknown>) => {
  return <Text as="p">{children}</Text>;
};
